import { IIndicatorData } from "./iindicator-data-strategy";
import { IndicatorData } from "./indicator-data";

export class MonthlyBalanceIndicatorData implements IIndicatorData {
  private readonly name: string = "MonthlyBalance";

  constructor(private readonly items: IndicatorData[]) {}

  getName(): string {
    return this.name;
  }

  getMonths(): Array<string> {
    const months = new Array<string>();

    this.items.forEach((item) => {
      months.push(item.getKey());
    });

    return months;
  }

  getValues(): Array<number> {
    const values = new Array<number>();

    this.items.forEach((item) => {
      values.push(Number(item.getValue().toFixed(2)));
    });

    return values;
  }
}
